import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhixian",
  "use": "icon-zhixian-usage",
  "viewBox": "0 0 12288 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 12288 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zhixian\"><path d=\"M0 0h12288v1024H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol